import { EDIT_PROJECT_USER, PROJECT_USER_SUCCESS, RESET_PROJECT_USER, SET_CURRENT_PROJECT, UNSET_CURRENT_PROJECT } from "./actionTypes"

export const editProjectUser = user => {
  return {
    type: EDIT_PROJECT_USER,
    payload: { user },
  }
}

export const projectUserSuccess = msg => {
  return {
    type: PROJECT_USER_SUCCESS,
    payload: msg,
  }
}


export const resetProjectUser = error => {
  return {
    type: RESET_PROJECT_USER,
  }
}

export const setCurrentProject = projectId => {
  return {
    type: SET_CURRENT_PROJECT,
    payload: projectId
  }
}

export const unsetCurrentProject = () => {
  return {
    type: UNSET_CURRENT_PROJECT
  }
}
